import { useEffect } from "react";
import { useSelector } from "react-redux";
import { identifyUser } from "utils/exponea";
import * as userSelectors from "redux/user/selectors";

export const useBloomreachInit = () => {
  const userData = useSelector(userSelectors.all) || "";

  useEffect(() => {
    if (exponea && userData.id && userData.login) {
      identifyUser(
        // eslint-disable-next-line camelcase
        { registered: userData.login, user_id: userData.id },
        {
          email: userData.login,
          ...(userData.name && { firstName: userData.name }),
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData.id]);
};
